var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorBattery0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9192 5.39393C15.1367 4.8863 14.9016 4.29842 14.3939 4.08087C13.8863 3.86331 13.2984 4.09846 13.0809 4.60609L7.08087 18.6061C6.86331 19.1137 7.09846 19.7016 7.60609 19.9192C8.11372 20.1367 8.7016 19.9016 8.91916 19.3939L9.73084 17.5H16.1233C17.6395 17.5 18.8733 16.2662 18.8733 14.75C19.3595 14.75 19.8259 14.5568 20.1697 14.213C20.5135 13.8692 20.7066 13.4029 20.7066 12.9167V11.0833C20.7066 10.5971 20.5135 10.1308 20.1697 9.78697C19.8259 9.44315 19.3595 9.25 18.8733 9.25C18.8733 7.73383 17.6395 6.5 16.1233 6.5H14.4451L14.9192 5.39393ZM13.6594 8.33333L10.5166 15.6667H16.1233C16.6284 15.6667 17.04 15.256 17.04 14.75V9.25C17.04 8.744 16.6284 8.33333 16.1233 8.33333H13.6594Z",
    fill: "#7A787A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03998 6.5H10.2691L9.48343 8.33333H6.03998C5.53489 8.33333 5.12331 8.744 5.12331 9.25V14.75C5.12331 15.256 5.53489 15.6667 6.03998 15.6667H6.34057L5.57194 17.4601C4.27786 17.2373 3.28998 16.1067 3.28998 14.75V9.25C3.28998 7.73383 4.52381 6.5 6.03998 6.5Z",
    fill: "#7A787A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorBattery0);
export default __webpack_public_path__ + "static/media/color-battery-0.81fbdacc74751554d9184fa4234b7f79.svg";
export { ForwardRef as ReactComponent };